import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SITE } from "@/config/site";

// Public site settings (contact details, socials, logo) editable from the admin
// panel without code changes. Falls back to config/site.js when unset.
let cache = null;

export const useSiteSettings = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    if (cache) {
      setSettings(cache);
      return;
    }
    api
      .get("/settings/public")
      .then((r) => {
        cache = r.data;
        setSettings(r.data);
      })
      .catch(() => {});
  }, []);

  const socialsFromApi = (settings?.socials || {});
  return {
    email: settings?.display_email || SITE.email,
    phone: settings?.phone || SITE.phone,
    phoneHref: settings?.phone ? `tel:${settings.phone.replace(/[^+\d]/g, "")}` : SITE.phoneHref,
    address: settings?.address || SITE.indiaOffice,
    logoUrl: settings?.logo_url || null,
    socials: SITE.socials.map((s) => ({
      ...s,
      href: socialsFromApi[s.label.toLowerCase()] || s.href,
    })),
  };
};
